module.exports = __webpack_public_path__ + "static/media/ic-copy.6eecd492.svg";